import React from 'react';
import './DocumentHeader.css';

const DocumentHeader = ({children, openTab}) => {
    const [TextHeader, CopyButton] = children;
    return <header className='padded header document fullWidth'>{TextHeader}{openTab==='Read' && CopyButton}</header>
}

export default DocumentHeader;